import React from 'react';
import styled from 'styled-components';

export const Privacy = (): React.ReactElement => {
  return (
    <div>
      <BlueH2>Online Privacy Policy Statement</BlueH2>
      <br />
      <h4>
        NOTICE: YOUR USE OF THIS SITE MEANS THAT YOU ACCEPT THE FOLLOWING PRIVACY POLICY STATEMENT AND ALL OF ITS TERMS.
      </h4>
      <br />
      <p>
        LiveXchange (Barbados) Limited, together with its affiliate, PayShark, Inc. (LiveXchange), provides this Online
        Privacy Policy Statement regarding your use of www.livexchange.com (the Website), together with any other
        websites, features, applications, widgets or online services that are owned or controlled by LiveXchange and
        that post a link to this Privacy Policy Statement (together with the Website, these all describe
        LiveXchange&apos;s Marketplace). This Policy also describes the choices available to you regarding the use of
        your personal information, your access to it, and how to update and correct it. LiveXchange is committed to
        respecting and protecting your privacy. We&apos;ve structured our Website so that, in general, you can visit
        LiveXchange on the Web without identifying yourself or revealing any of your personal information. Once you
        choose to create a Marketplace Profile and provide us with your personal identifiable information (any
        information by which you can be identified, Personal Information), you can be assured that it will only be used
        to support your relationship with LiveXchange, and your use of its online Marketplace.
      </p>
      <p>
        This Online Privacy Policy Statement covers the five foundational principles of the fair handling and privacy of
        Personal Information: Awareness, Choice, Accuracy & Access, Security, and Oversight.
      </p>
      <br />
      <CenterH4>Awarness</CenterH4>
      <br />
      <p>
        This Online Privacy Policy Statement is to make you aware of our policies and procedures regarding the
        collection, use, and disclosure of information through the Website, as well as the choices you can make about
        the way your information is collected and used. To make this Policy easy to find, we provide a link to it at the
        bottom of every page of our Website and online Marketplace.
      </p>
      <br />
      <CenterH4>What We Collect</CenterH4>
      <br />
      <p>
        The types of personal information collected on the pages of our Website are those deemed necessary for your use
        of, and participation in, LiveXchange&apos;s Marketplace, as a Provider (or User) of Customer Experience
        Services. This information includes, without limitation, your: name, physical and email addresses, work
        background, skill sets, contact information, and limited financial information (only to the extent necessary for
        you to use PayShark&apos;s collection/payment services and/or in connection with a background and/or credit
        check on you, where applicable). In addition, some pages on our Website may use a data analysis technique called
        Cookies.
      </p>
      <br />
      <CenterH4>How We Use It</CenterH4>
      <br />
      <p>
        LiveXchange uses your Personal Information only in order to facilitate your use of the Marketplace.
        Specifically, we use your Personal Information to establish and update your ability to provide/use Customer
        Experience Services, and to better communicate back to you. From time to time, we may also use your Personal
        Information to contact you for market research or to provide you with marketing information we think would be of
        particular interest. At a minimum, we will always give you the opportunity to opt-out of receiving such direct
        marketing or market research contact. We will also follow local requirements, such as allowing you to opt-in
        before receiving unsolicited contact, where applicable. For example, California residents may have the following
        rights under the California Consumer Privacy Act (CCPA): the right to access your personal information, right to
        deletion, right to disclosure, right to opt out of sales, and right to be free from discrimination. If you are a
        Californian resident, you can contact us to exercise your rights. For compliance purposes, we may require
        additional information from you in order to honor your request and we may decline your request as permitted
        under the Applicable Laws.
      </p>
      <br />
      <CenterH4>With Whom We Share It</CenterH4>
      <br />
      <p>
        The information contained in your LiveXchange Marketplace Profile is released only to the Users of Customer
        Experience Services in the Marketplace to whom you seek to offer your Services. Your Personal Information may
        also be released to entities that perform background and/or credit checks, when such screening steps are
        required by Service Users for certain Gigs (i.e. work projects that last a certain period of time – which can be
        short-term and of specified length, or long-term and lasting as long as the need continues) on which you seek to
        offer your Services. You hereby grant LiveXchange permission to forward your Profile for each Gig upon which
        your Customer Experience Services are sought, solicited, or performed. You also grant LiveXchange permission to
        release your Personal Information to entities that perform background and/or credit checks, where necessary.
        LiveXchange will not sell, rent, or lease your personal identifiable information to others. Unless we have your
        permission or are required by law, we will only share the personal data you provide online with other
        LiveXchange entities who are acting on our behalf for the uses described above (in the How We Use It section).
        Such LiveXchange entities are governed by our privacy policies with respect to the use of this data and are
        bound by appropriate confidentiality agreements.
      </p>
      <br />
      <CenterH4>Children&apos;s Privacy Protection</CenterH4>
      <br />
      <p>
        LiveXchange takes special care to protect the privacy needs of children under the age of 18 and encourages
        parents to be an active participant in their child&apos;s online activities and interests. We abide by the
        Children&apos;s Online Privacy Protection Act (COPPA) requirements. Our Website does not target, nor is it
        intended for children under the age of 18; and we will not knowingly collect data from them. If we discover
        personal data from a child through an adult-oriented site, we will eliminate that data.
      </p>
      <br />
      <CenterH4>Choice</CenterH4>
      <br />
      <p>
        LiveXchange will not use or share the personal identifiable information provided to us online in ways unrelated
        to the ones described herein without first letting you know and offering you a choice. We adhere to local
        country laws and policies, where applicable. We will always secure your permission first, should we ever share
        your information with third-parties that are not acting on our behalf nor governed by our privacy policy.
      </p>
      <br />
      <CenterH4>Accuracy & Access</CenterH4>
      <br />
      <p>
        LiveXchange strives to keep your Personal Information accurate. We will provide you with access to your
        information, including making every effort to provide you with online access to your Marketplace Profile
        registration data so that you may view it, and update or correct it on our Website, where it was submitted. To
        protect your privacy and security, we will also take reasonable steps to verify your identity before granting
        you access or enabling you to make corrections. To access your Personal Information, return to the web page
        where you originally entered it and follow the instructions on that web page. Certain areas of
        LiveXchange&apos;s Website limit access to specific individuals through the use of passwords and through
        providing personal data. Links to third-party websites on LiveXchange&apos;s Website are provided solely as a
        convenience to you. If you use these links, you will leave the LiveXchange Website. LiveXchange has not
        necessarily reviewed all of these third-party sites and does not control and is not responsible for any of these
        sites, their content, or their privacy policy. Thus, LiveXchange does not endorse or make any representations
        about such third-party sites, any information, software or other products or materials found there, or any
        results that may be obtained from using them. If you decide to access any of the third-party sites linked to
        this site, you do so at your own risk.
      </p>
      <br />
      <CenterH4>Security</CenterH4>
      <br />
      <p>
        LiveXchange is committed to ensuring the security of your Personal Information. To prevent unauthorized access
        or disclosure, maintain data accuracy, and ensure the appropriate use of information, we have put in place
        appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect
        online. We use encryption when collecting or transferring sensitive data such as your personal information. The
        secure data transfer and validation process between LiveXchange and the Users of its Marketplace is subject to,
        and bound by, contractual and confidentiality agreements.
      </p>
      <br />
      <CenterH4>Oversight</CenterH4>
      <br />
      <p>
        If you have comments or questions about our privacy policy, please contact us via the information displayed in
        the Contact section of our Website.
      </p>
      <br />
      <CenterH4>How LiveXchange Uses Cookies</CenterH4>
      <br />
      <p>
        A Cookie is small text data file sent to your computer (or other device) while browsing, for purposes of making
        websites work (or work more efficiently), and to differentiate your from other users, or provide operational
        information to us. You will always be asked for your permission before a Cookie is placed on your device. If you
        agree, then your browser adds the text in a small file. The purpose of a Cookie is to help us analyze traffic on
        our Website, or to let us know when you visit a particular page of our Website. Cookies allow a web application
        to respond to you as an individual. By gathering and remembering information, the web application can tailor its
        operation to you. LiveXchange uses traffic log Cookies to identify what pages are being used and which ones are
        not. This helps us aggregate and analyzes data about web page traffic and makes improvements to
        LiveXchange&apos;s Marketplace to better meet customer needs. In this case, LiveXchange uses this information
        only for statistical analysis purposes and then the data is removed from the system. That is the case with many
        of our support and information-sharing pages and forums. You may set your web browser (Microsoft Internet
        Explorer, Google Chrome, Apple Safari, or other browser) to notify you of Cookie placement requests, or for you
        to decline Cookies completely. You can delete the files that contain Cookies; from where those files are stored
        as part of your internet browser. .Denial of a traffic log Cookie should not prevent you from using one of our
        Websites.
      </p>
      <br />
      <CenterH4>Please Note</CenterH4>
      <br />
      <p>
        Your continued use of our Website constitutes your acceptance of the foregoing Privacy Policy Statement, and all
        of its terms.
      </p>
    </div>
  );
};

const BlueH2 = styled.h2`
  color: #008acd;
`;

const CenterH4 = styled.h4`
  text-align: center;
`;
